import React from 'react';
import { Grid } from '@material-ui/core';
import { ChevronRight, ChevronLeft } from 'react-feather';

const absolute: 'absolute' = 'absolute';

const arrowStyles = {
  position: absolute,
  zIndex: 2,
  top: 16,
  right: '0px !important',
  border: 'none',
  cursor: 'pointer',
  height: '131px',
  width: '36px',
  padding: '0px !important',
};

const renderArrowNext = (
  onClickHandler: any,
  hasNext: boolean,
  label: string,
) =>
  hasNext && (
    <Grid
      container
      justify="center"
      alignContent="center"
      onClick={onClickHandler}
      title={label}
      style={{
        ...arrowStyles,
        right: 0,
        borderRadius: '13.5px 0 0 13.5px',
      }}
    >
      <ChevronRight color="#DADADA" size={20} />
    </Grid>
  );

const renderArrowPrev = (
  onClickHandler: any,
  hasPrev: boolean,
  label: string,
) =>
  hasPrev && (
    <Grid
      container
      justify="center"
      alignContent="center"
      onClick={onClickHandler}
      title={label}
      style={{
        ...arrowStyles,
        left: 0,
        borderRadius: '0 13.5px 13.5px 0',
      }}
    >
      <ChevronLeft color="#DADADA" size={20} />
    </Grid>
  );

const indicatorStyles = {
  display: 'inline-block',
  margin: '0 2.4px',
  height: '9.6px',
  width: '9.6px',
  opacity: '0.36',
  backgroundColor: '#000000',
  borderRadius: '100%',
  bottom: '12px',
  right: '40px',
  cursor: 'pointer',
};

const renderIndicator = (
  onClickHandler: any,
  isSelected: boolean,
  index: number,
  label: string,
) =>
  isSelected ? (
    <li
      style={{
        ...indicatorStyles,
        backgroundColor: '#FFFFFF',
        opacity: 1,
      }}
      aria-label={`Selected: ${label} ${index + 1}`}
      title={`Selected: ${label} ${index + 1}`}
    />
  ) : (
    <li
      style={indicatorStyles}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    />
  );

export { renderArrowPrev, renderArrowNext, renderIndicator };
